import React, {Component} from "react";
import {withRouter} from "react-router-dom";

import BaseBtn from "../../Buttons/BaseBtn";
import * as Utils from "../../Utils";

class PageTopMenu extends Component {
    state = {
        date: new Date(),
        back: false,
        isPageRedirect: false
    }

    onClick = () => {
        let audio = new Audio();
        audio.pause();
        this.props.history.push("/app/homework");
    }

    render() {
        const date = Utils.getDate();
        const years = date.getFullYear();
        const months = Utils.twoDigits(date.getMonth() + 1);
        const days = Utils.twoDigits(date.getDate());

        return (
            <div className="pageTopMenu">
                <BaseBtn btnColor="blue" btnName="오늘의 숙제" onClick={this.onClick}/>
                <span className="today">
                    {years}년 {months}월 {days}일
                </span>
            </div>
        );
    }
}

PageTopMenu.defaultProps = {
    onClick: () => {
    }
}
export default withRouter(PageTopMenu);



// WEBPACK FOOTER //
// ./src/components/Containers/PageTopMenu/index.js